import { Box, Button, LinearProgress, Link, Stack } from "@mui/material";
import { Page } from "../../modules/layout/components/page";
import { PageContent } from "../../modules/layout/components/page-content";
import { PageHeader } from "../../modules/layout/components/page-header";
import { PageHeading } from "../../modules/layout/components/page-heading";
import { MomentFilter } from "../../modules/moment-filter/components/moment-filter";
import { LiveSearchField } from "../../modules/search/live-search-field";
import { useCombinedSearch } from "../../modules/tabbed-programs/hooks/use-combined-search";
import { MomentGrid } from "../../modules/tabbed-programs/moment-grid";
import { ProgramGrid } from "../../modules/tabbed-programs/program-grid";

import type { FC } from "react";

const TabbedProgramsPage: FC = () => {
  const { data, loading } = useCombinedSearch();

  return (
    <Page title="Your Programs | ChangeEngine">
      <PageHeader sx={{ display: "flex" }}>
        <PageHeading heading="Your Programs" subheading="Manage your Communications and Programs">
          <Button
            data-analytics-id="tabbed-programs-create-program"
            LinkComponent={Link}
            href="/manage/programs"
            color="primary"
            variant="contained"
          >
            Create Program
          </Button>
        </PageHeading>
      </PageHeader>

      <PageContent>
        <Stack direction="row" sx={{ justifyContent: "space-between", mt: 4 }}>
          <Box sx={{ minWidth: 350, maxWidth: 510 }}>
            <LiveSearchField label="Search Communications & Programs" />
          </Box>
          <MomentFilter displayEventOptions={false} displaySegmentOptions={false} />
        </Stack>
        {loading || !data ? (
          <LinearProgress sx={{ mt: 2 }} />
        ) : (
          <>
            <ProgramGrid programs={data.programs} />

            <MomentGrid moments={data.moments} showProgram sx={{ mt: 4 }} />
          </>
        )}
      </PageContent>
    </Page>
  );
};

export default TabbedProgramsPage;
